import React from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import WorkSection from "./components/WorkSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { siteContent, siteSections } from "./content/site";
import useTheme from "./hooks/useTheme";
import useActiveSection from "./hooks/useActiveSection";

const HEADER_OFFSET = 76;
const sectionLinks = siteSections.map((section) => ({
  text: section.label,
  link: section.id,
}));
const sectionIds = sectionLinks.map((sectionLink) => sectionLink.link);

const App: React.FC = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const activeSection = useActiveSection(sectionIds, HEADER_OFFSET);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);

    if (!element) {
      return;
    }

    const top = element.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  return (
    <div className="App app-shell">
      <Navbar
        brandName={siteContent.person.brandName}
        menuItems={sectionLinks}
        activeSection={activeSection}
        isDarkMode={isDarkMode}
        onNavigate={scrollToSection}
        onToggleTheme={toggleTheme}
      />
      <main className="app-main">
        <HeroSection />
        <WorkSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;
